<template>
  <div class="mnd-step">
    <div class="mnd-step__content mnd-step__content_slim">
      <h4 class="mnd-step__minititle">Адрес имущества</h4>
      <TextInput :selectonly="true" :optionsFunction="genCity" :required="true" @setError="errors.city = $event" v-model="form.address.city" text="Населённый пункт" name="city" />
      <TextInput :selectonly="true" :optionsFunction="genStreet" v-if="!form.address.nostreet" :disabled="streetDisabledCondition" :required="true" @setError="errors.street = $event" v-model="form.address.street" text="Улица" name="street" />
      <CheckBox name="nostreet" v-model="form.address.nostreet">
        Отсутствует улица
      </CheckBox>
      <ShortFields>
        <TextInput :selectonly="true" :optionsFunction="genHouse" :required="true" :disabled="houseDisabledCondition" @setError="errors.house = $event" v-model="form.address.house" text="Дом" name="house" />
        <TextInput :required="true" :disabled="flatDisabledCondition" :optionsFunction="genFlat" @setError="errors.flat = $event" v-model="form.address.flat" text="Квартира" name="flat" />
      </ShortFields>

      <h4 class="mnd-step__minititle mnd-mt0">Страхователь</h4>

      <TextInput :optionsFunction="genSURNAME" :required="true" @setError="errors.surname = $event" v-model="form.personal.surname" text="Фамилия" name="surname" />
      <TextInput :optionsFunction="genNAME" :required="true" @setError="errors.name = $event" v-model="form.personal.name" text="Имя" name="name" />
      <TextInput :optionsFunction="genPATRONYMIC" :required="true" @setError="errors.patronymic = $event" v-model="form.personal.patronymic" text="Отчество" name="patronymic" />
      <ShortFields>
        <DateInput :required="true" :validation="birthdateval" @setError="errors.birthdate = $event" name="birthdate" text="Дата рождения" :range="false" v-model="form.personal.birthdate" />
        <SelInput :required="true" text="Пол" name="sex" :options="['', 'Мужской', 'Женский']" v-model="form.personal.sex" />
      </ShortFields>
      <TextInput :optionsFunction="birthPlaceSuggest" :required="true" @setError="errors.birthplace = $event" v-model="form.personal.birthplace" text="Место рождения" name="birthplace" />
      <h4 class="mnd-step__minititle mnd-mt0">Паспорт гражданина РФ</h4>
      <ShortFields>
        <NumberInput :required="true" mask="#### ######" @setError="errors.number = $event" :filled="(v) => v.length == 11" v-model="form.passport.number" text="Серия и номер паспорта" name="passport-number" />
        <DateInput :required="true" @setError="errors.releasedate = $event" v-model="form.passport.releasedate" text="Дата выдачи" name="releasedate" />
      </ShortFields>
      <h4 class="mnd-step__minititle mnd-mt0">Контактная информация</h4>
      <NumberInput :required="true" mask="+7 (###) ###-##-##" @setError="errors.tel = $event" :filled="(v) => v.length == 18" v-model="form.contacts.tel" text="Телефон" name="tel" />
      <EmailInput :required="true" @setError="errors.email = $event" v-model="form.contacts.email" text="E-mail" name="email" />
      <CheckBox :smtext="true" :tostart="true" name="agreement" v-model="form.agreement">
        Я ознакомился с <a class="mnd-newred" href="/docs/soglashenie_o_poryadke_elektronnogo_vzaimodei_stviya.pdf" target="_blank">политикой обработки</a> персональных данных (ПД) и даю согласие на <a class="mnd-newred" href='/about/politics/' target="_blank">обработку ПД</a>.
      </CheckBox>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TextInput from '@/components/inputs/TextInput.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import EmailInput from '@/components/inputs/EmailInput.vue'
import NumberInput from '@/components/inputs/NumberInput.vue'
import SelInput from '@/components/inputs/SelInput.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import ShortFields from '@/components/ShortFields.vue'
import birthdateValidation from '@/mixins/birthdateValidation';

export default {
  data: () => ({
    errors: {},
    dadataLevels: {
      city: [],
      street: [],
      house: [],
      flat: []
    },
  }),
  props: {
    filledStatus: { type: Object },
    index: { type: Number, default: 2 }
  },
  components: {
    TextInput, DateInput, EmailInput, NumberInput, SelInput, CheckBox, ShortFields
  },
  mixins: [birthdateValidation],
  computed: {
    ...mapState(['form', 'dadata_urls', 'DaDataToken']),
    streetDisabledCondition() {
      if (!this.form.address.city || this.errors.city)
        return true
      return false
    },
    houseDisabledCondition() {
      if (this.form.address.nostreet)
        return this.streetDisabledCondition
      else {
        if (!this.form.address.street || this.errors.street) {
          return true
        }
        return false
      }
    },
    flatDisabledCondition() {
      if (!this.form.address.house || this.errors.house)
        return true
      return false
    },
    filled() {
      if (this.$store.state.devMode || this.$store.state.skipForm)
        return true
      for (let key in this.errors)
        if (this.errors[key]) return false

      let required = [
        'address.city',
        'address.house',
        'address.flat',
        'personal.name',
        'personal.surname',
        'personal.patronymic',
        'personal.birthdate',
        'personal.sex',
        'personal.birthplace',
        'passport.number',
        'passport.releasedate',
        'contacts.tel',
        'contacts.email',
        'agreement'
      ]

      if (!this.form.address.nostreet)
        required.push('address.street')

      for (let key of required) {
        let v = this.form
        let parsed
        //const kkey = key
        while (key) {
          let k = key.match(/[^.]*/)[0]
          key = key.replace(k, '').replace(/^\./, '')
          if (k || (key === 0)) {
            v = v[k]
            parsed = true
          }
        }
        if (!parsed || !v) {
          //console.log(kkey)
          return false
        }
      }
      return true
    }
  },
  methods: {
    genCity(v) {
      return this.addressPartSuggest(v, 'city')
    },
    genStreet(v) {
      return this.addressPartSuggest(v, 'street')
    },
    genHouse(v) {
      return this.addressPartSuggest(v, 'house')
    },
    genFlat(v) {
      return this.addressPartSuggest(v, 'flat')
    },
    genSURNAME(v) {
      return this.suggestFIOpart(v, 'SURNAME')
    },
    genNAME(v) {
      return this.suggestFIOpart(v, 'NAME')
    },
    genPATRONYMIC(v) {
      return this.suggestFIOpart(v, 'PATRONYMIC')
    },
    async suggestFIOpart(val, part) {
      let url = this.dadata_urls.fio,
        token = this.DaDataToken,
        query = val,
        gender = 'UNKNOWN',
        parts = ["NAME", "SURNAME", "PATRONYMIC"]

      if (part && (["NAME", "SURNAME", "PATRONYMIC"].includes(part)))
        parts = [part]

      switch (this.form.personal.sex) {
        case 'Мужской':
          gender = 'MALE'
          break
        case 'Женский':
          gender = 'FEMALE'
          break
      }

      let options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Token " + token
        },
        body: JSON.stringify({ query, gender, count: 5, parts })
      }

      let sg = await (fetch(url, options)
        .then(response => response.json())
        .then(res => { return res.suggestions.map(el => el.value) })
        .catch(() => []))

      return sg
    },
    async birthPlaceSuggest(query) {
      let url = this.dadata_urls.address,
        token = this.DaDataToken,
        options = {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": "Token " + token
          },
          body: JSON.stringify({
            query: query,
            count: 5,
            to_bound: { "value": "settlement" },
            "locations": [
              {
                "country_iso_code": "*"
              }
            ]
          })
        }
      let sg = await (fetch(url, options)
        .then(response => response.json())
        .then(json => json.suggestions)
        .catch(() => []))
      return sg.map(el => el.value)
    },
    getPrecisestLocation(part) {
      let locations = []
      const levels = ['city', 'settlement', 'street', 'house', 'flat']

      const check_ids = (truePart, parentPart) => {
        if (this.form.address.dadataChosen[truePart].data[parentPart + '_fias_id'])
          return { [parentPart + '_fias_id']: this.form.address.dadataChosen[truePart].data[parentPart + '_fias_id'] }

        //if (this.form.address.dadataChosen[truePart].data[parentPart + '_kladr_id'])
        //return { [parentPart + '_kladr_id']: this.form.address.dadataChosen[truePart].data[parentPart + '_kladr_id'] }

        return false
      }

      let idx = levels.indexOf(part)
      if (idx == -1) {
        throw 'Ошибка getPrecisestLocation: idx -1'
      } else {
        let parentPart = levels[idx - 1]
        if (parentPart) {
          if ((parentPart == 'street') && (this.form.address.nostreet))
            parentPart = 'settlement'
          let truePart = (parentPart == 'settlement') ? 'city' : parentPart
          let result = check_ids(truePart, parentPart)
          if (!result && (truePart != parentPart))
            result = check_ids(truePart, truePart)
          if (result)
            locations[0] = result
          else {
            throw 'Ошибка getPrecisestLocation: no kladr'
          }
        }
      }
      return locations
    },
    async addressPartSuggest(query, part) {
      const settings = {
        query: query,
        count: 8,
        restrict_value: true
      }
      try {
        switch (part) {
          case 'city':
            settings.from_bound = { "value": "city" }
            settings.to_bound = { "value": "settlement" }
            break
          case 'street':
            settings.from_bound = { "value": "street" }
            settings.to_bound = { "value": "street" }
            settings.locations = this.getPrecisestLocation(part)
            break
          case 'house':
            settings.from_bound = { "value": "house" }
            settings.to_bound = { "value": "house" }
            settings.locations = this.getPrecisestLocation(part)
            break
          case 'flat':
            settings.from_bound = { "value": "flat" }
            settings.to_bound = { "value": "flat" }
            settings.locations = this.getPrecisestLocation(part)
            delete settings.restrict_value
            break
        }
      } catch (err) {
        this.errors[part] = 'Ошибка поиска локации'
        this.dadataLevels[part] = []
        return console.error(err)
      }

      let url = this.dadata_urls.address,
        token = this.DaDataToken,
        options = {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": "Token " + token
          },
          body: JSON.stringify(settings)
        }
      let additionalPart = (part == 'city') ? 'settlement' : part
      let sg = await (fetch(url, options)
        .then(response => response.json())
        .then(json => json.suggestions.filter(el => {
          if (!el.data[part + '_fias_id'] && !el.data[additionalPart + '_fias_id'])
            return false

          if (!el.data[part + '_kladr_id'] && !el.data[additionalPart + '_kladr_id'])
            return false

          return true
        }))
        .then(filtered => filtered.slice(0, 5))
        .catch(() => []))
      this.dadataLevels[part] = sg
      return sg.map(el => el.value)
    },
  },
  watch: {
    filled: {
      immediate: true,
      handler(value) {
        //eslint-disable-next-line
        this.filledStatus[this.index] = value
      }
    },
    'form.address.city': function (v, old) {
      if (v != old) {
        this.form.address.street = ''
        this.form.address.house = ''
        this.form.address.flat = ''

        let data = this.dadataLevels.city?.find(el => el.value == v)
        if (!data) {
          this.form.address.dadataChosen.city = null
        } else {
          this.form.address.dadataChosen.city = data
        }
      }
    },
    'form.address.nostreet': function (v, old) {
      if (v != old) {
        this.form.address.street = ''
        this.form.address.house = ''
        this.form.address.flat = ''
      }
    },
    'form.address.street': function (v, old) {
      if (v != old) {
        this.form.address.house = ''
        this.form.address.flat = ''

        let data = this.dadataLevels.street?.find(el => el.value == v)
        if (!data) {
          this.form.address.dadataChosen.street = null
        } else {
          this.form.address.dadataChosen.street = data
        }
      }
    },
    'form.address.house': function (v, old) {
      if (v != old) {
        this.form.address.flat = ''

        let data = this.dadataLevels.house?.find(el => el.value == v)
        if (!data) {
          this.form.address.dadataChosen.house = null
        } else {
          this.form.address.dadataChosen.house = data
        }
      }
    },
  }
}
</script>

<style lang="sass" scoped>

</style>